(function ($) {
  
    // Be more specific with the selector
    const $nav = $(".account-navigation-mobile .woocommerce-MyAccount-navigation");
    
    // Check if the element exists before proceeding
    if (!$nav.length) return;
    
    const $navList = $nav.find("ul").first();
  
    // Get the active menu item text or default to "Dashboard"
    const activeText = $nav.find("li.is-active a").text() || "Dashboard";
  
    // Wrap the list in a content div
    $navList.wrap('<div class="accordion-content"></div>');
  
    // Create and prepend the header with active text
    const $header =
      $(`<div class="accordion-header"><p class="active-mobile-item">${activeText}</p><span class="toggle-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M16 10L12 14L8 10" stroke="#242526" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg></span></div>`);
    $nav.prepend($header);
  
    // Initially hide the content
    $navList.parent(".accordion-content").hide();
  
    // Handle click event
    $header.on("click", function () {
      const $content = $(this).next(".accordion-content");
      const $icon = $(this).find(".toggle-icon");
  
      $content.slideToggle();
      $(this).toggleClass("is-active");
    });
  
    // Update header text when clicking menu items
    $navList.find("a").on("click", function () {
        const newText = $(this).text();
        //$header.find(".active-mobile-item").text(newText);
      });
  })(jQuery);